// import faker from 'faker';
class DataService {
  /*
   * there is just one unique depot_id in the current DataSet
   * data contains duplicates
   * */

  constructor() {
    this.routes = require('./../data/routes.json');
    this.totalStops = this.getStops().length;
    this.totalDistance = this.routes.reduce(
      (acc, item) => acc + item.distance,
      0
    );
  }

  getRoutes() {
    return this.routes;
  }

  // UTILITY METHODS FOR FINDING THINGS IN ROUTES COLLECTION (App State)
  // USE App.getStops instead
  getStops(routes = this.routes) {
    const stops = routes
      .map(route => {
        return route.stops.map(stop => {
          return {
            route_id: route.id,
            ...stop,
          };
        });
      })
      .flat();
    return stops;
  }
}
export default new DataService();
